import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import Table from "../common/Table";
import Button from "../common/Button";
import { partnerService } from "../../services/partners";

const PartnerList = ({ filters, onEdit, onDelete }) => {
  const navigate = useNavigate();
  const { data: partners, isLoading } = useQuery({
    queryKey: ["partners", filters],
    queryFn: () => partnerService.getAll(filters),
  });

  const columns = [
    { header: "DLC ID", accessor: "dlcId" },
    { header: "Name", accessor: "name" },
    { header: "Company", accessor: (row) => row.company || "-" },
    { header: "Type", accessor: (row) => {
      const types = { commission: "Commission", revenue_share: "Revenue Share", fixed: "Fixed", hybrid: "Hybrid" };
      return types[row.partnerType] || row.partnerType;
    }},
    { header: "Commission %", accessor: (row) => row.commissionRate ? `${row.commissionRate}%` : "-" },
    { header: "Total Revenue", accessor: (row) => `₹${(row.totalRevenue || 0).toLocaleString("en-IN")}` },
    { header: "Total Earnings", accessor: (row) => `₹${(row.totalEarnings || 0).toLocaleString("en-IN")}` },
    { header: "Status", accessor: (row) => (
      <span className={`px-2 py-1 rounded-full text-xs font-medium ${
        row.status === "active" ? "bg-green-100 text-green-700" :
        row.status === "inactive" ? "bg-gray-100 text-gray-700" :
        "bg-red-100 text-red-700"
      }`}>{row.status}</span>
    )},
  ];

  const actions = (row) => (
    <div className="flex gap-2 justify-end">
      <Button size="sm" variant="secondary" onClick={() => navigate(`/partners/${row._id}`)}>View</Button>
      {onEdit && <Button size="sm" onClick={() => onEdit(row)}>Edit</Button>}
      {onDelete && <Button size="sm" variant="danger" onClick={() => onDelete(row._id)}>Delete</Button>}
    </div>
  );

  if (isLoading) return <div>Loading...</div>;

  return <Table columns={columns} data={partners} actions={actions} />;
};

export default PartnerList;
